var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMarriage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 62,
    height: 62,
    rx: 31,
    fill: "#FDE1D8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31 42C30.79 42 30.58 41.934 30.403 41.802C29.938 41.456 19 33.243 19 27C19 23.141 22.141 20 26 20C28.358 20 30.062 21.272 31 22.212C31.938 21.272 33.642 20 36 20C39.859 20 43 23.14 43 27C43 33.243 32.062 41.456 31.597 41.803C31.42 41.934 31.21 42 31 42Z",
    fill: "#EF4754"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarriage);
export default __webpack_public_path__ + "static/media/marriage.3d4f017d2ec1b9fc86227699cbe80f4a.svg";
export { ForwardRef as ReactComponent };